import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsOptional, Matches, MaxLength } from "class-validator";

export class VendorRequestDto{
  @ApiProperty()
  @IsNotEmpty()
  vendorId: number;
}